import React from 'react';

interface Props {
  onLogout: () => void;
}

const LogoutPortal = ({ onLogout }: Props) => {
  const params = new URLSearchParams(location.search);
  const portalBase = params.get('portalBase');
  onLogout();
  window.location.href = portalBase;
  
  return null;
};

export default LogoutPortal;
